package com.merkost.handpass.admin.contract

import com.merkost.handpass.api.dto.admin.ModerationLogEntry
import pro.respawn.flowmvi.api.MVIAction
import pro.respawn.flowmvi.api.MVIIntent
import pro.respawn.flowmvi.api.MVIState

data class LogState(
    val actionFilter: String = "All",
    val adminId: String = "",
    val page: Int = 1,
    val totalPages: Int = 1,
    val data: AsyncSection<List<ModerationLogEntry>> = AsyncSection.Loading,
    val sortBy: String? = null,
    val sortAsc: Boolean = false,
    val dateFrom: String? = null,
    val dateTo: String? = null,
) : MVIState

val LOG_ACTION_FILTERS = listOf("All", "WARN_USER", "SUSPEND_USER", "BAN_USER", "RESTORE_USER", "SUSPEND_LISTING", "RESTORE_LISTING")

sealed interface LogIntent : MVIIntent {
    data class SetActionFilter(val value: String) : LogIntent
    data class SetAdminId(val value: String) : LogIntent
    data class GoToPage(val page: Int) : LogIntent
    data class TapTarget(val log: ModerationLogEntry) : LogIntent
    data class ReactToFocusTick(val tick: Long) : LogIntent
    data object Refresh : LogIntent
    data class SetSort(val sortBy: String, val sortAsc: Boolean) : LogIntent
    data class SetDateFrom(val value: String?) : LogIntent
    data class SetDateTo(val value: String?) : LogIntent
}

sealed interface LogAction : MVIAction {
    data class Navigate(val path: String) : LogAction
}
